import React from 'react';
import '../../styles/arTrailMap.css';
import { useViewport } from '../../util/hooks.js';
import { useParams } from "react-router-dom";
import { Instructions, Permissions, CompassIcon, PanoramicView, Monitoring, Video } from "./Components";
import Header from '../../components/Header';
import data from '../../data';

import { useDeviceOrientation } from '../../util/Orientation';
import { useGeolocation } from '../../util/Geolocation';
import { useCamera } from "../../util/Camera"
import { PERMISSION_STATUS } from '../../util/constants';

const ARTrailMap = () => {
  const { building } = useParams();
  const copy = data.copy.find( item => item.id === building);
  const {
    orientation,
    status: statusOrientation,
    startOrientation,
  } = useDeviceOrientation();

  const { 
    geolocation, 
    startGeolocation, 
    calcOrientationDegreesFromCurrentLocationToLandmark, 
    status: statusGeolocation 
  } = useGeolocation();

  const { 
    cameraStream, 
    startCamera, 
    status: statusCamera 
  } = useCamera();

  const { width, height } = useViewport();
  const mainRef = React.useRef(null);

  const [ panoramicWidth, setPanoramicWidth] = React.useState(0);
  const [ app, setApp] = React.useState({
    areInstructionsRead: false,
    arePermissionsAllowed: false,
  });

  React.useEffect( () => {
    mainRef.current.style.minHeight = `${height - 50}px`
    mainRef.current.style.height = `${height - 50}px`
  },[height])

  React.useEffect( () => {
    if(statusOrientation.status === PERMISSION_STATUS.CORRECT &&
      statusCamera.status === PERMISSION_STATUS.CORRECT &&
      statusGeolocation.status === PERMISSION_STATUS.CORRECT){
      setApp( (app) => {
        return {...app, arePermissionsAllowed: true}
      });
    }
  },[statusOrientation.status, statusCamera.status,statusGeolocation.status])

  const setUpBackgroundWidth = (clientWidth) => {
    setPanoramicWidth(clientWidth);
  }

  const startARMap = () => {
    setApp({
      ...app,
      areInstructionsRead: true,
    });
  }

  return (
    <div className="armap">
      <Header building={building}/>
      <div className="main" ref={mainRef}>
        <Instructions 
          areInstructionsRead={app.areInstructionsRead}
          startARMap={startARMap}
        />
        <div className="panoramic">
          {/* For monitoring values */}
          {process.env.REACT_APP_MONITORING_APP && 
            <Monitoring 
              orientation={orientation} 
              startGeolocation={startGeolocation}
              geolocation={geolocation}
            />
          }
          <Permissions
            arePermissionsAllowed={app.arePermissionsAllowed}
            startCamera={startCamera}
            startOrientation={startOrientation}
            startGeolocation={startGeolocation}
            statusCamera={statusCamera}
            statusGeolocation={statusGeolocation}
            statusOrientation={statusOrientation}
          />
          <CompassIcon 
            orientation={orientation}
          />
          <PanoramicView 
            data={copy}
            orientation={orientation}
            panoramicWidth={panoramicWidth}
            geolocation={geolocation}
            calcOrientationDegreesFromCurrentLocationToLandmark={calcOrientationDegreesFromCurrentLocationToLandmark}
          />
          <Video 
            cameraStream={cameraStream} 
            setUpBackgroundWidth={setUpBackgroundWidth} 
            width={width}
          />
        </div>
      </div>
    </div>
  );
}

export default ARTrailMap;
